import { cn } from '../../lib/utils'
import type { LucideIcon } from 'lucide-react'
import { pagePanel } from '../layout/page-styles'

interface StatCardProps {
  icon: LucideIcon
  label: string
  value: React.ReactNode
  hint?: React.ReactNode
  className?: string
  iconClassName?: string
  iconBgClassName?: string
}

export function StatCard({
  icon: Icon,
  label,
  value,
  hint,
  className,
  iconClassName = 'text-primary-600',
  iconBgClassName = 'bg-primary-50 ring-1 ring-primary-100',
}: StatCardProps) {
  return (
    <div className={cn(pagePanel, 'p-5 flex items-center justify-between gap-4', className)}>
      <div className='min-w-0'>
        <div className='text-2xl font-bold text-neutral-900 tracking-tight'>{value}</div>
        <div className='mt-1 text-sm font-medium text-neutral-600'>{label}</div>
        {hint ? <div className='mt-1.5 text-xs text-neutral-500'>{hint}</div> : null}
      </div>
      <div
        className={cn(
          'w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0',
          iconBgClassName
        )}
      >
        <Icon className={cn('w-6 h-6', iconClassName)} />
      </div>
    </div>
  )
}
